import { useGeneratedGetPricingTaskRunsByTypeForBusinessOrganizationQuery } from '@/experiences/sales-portal/domain/pricing-agent/blocs/documents/get-pricing-task-runs-by-type-for-business-organization.generated';
import { useMemo } from 'react';

interface UsePricingTaskRunsByTypeLoaderParams {
  hasPricingAgentAccess: boolean;
}

export const usePricingTaskRunsByTypeLoader = ({
  hasPricingAgentAccess,
}: UsePricingTaskRunsByTypeLoaderParams) => {
  const { data, error, loading, refetch } =
    useGeneratedGetPricingTaskRunsByTypeForBusinessOrganizationQuery({
      fetchPolicy: 'cache-and-network',
      notifyOnNetworkStatusChange: true,
      skip: !hasPricingAgentAccess,
    });

  return useMemo(
    () => ({
      error,
      loading,
      refetch,
      taskRuns:
        data?.getPricingTaskRunsByTypeForBusinessOrganization.task_runs ?? [],
    }),
    [data, error, loading, refetch],
  );
};
